export enum UserRolesEnum
{
    ent = "ENT",
    hcp = "HCP",
    dal = "DAL",
    none = "None",
}
